import React, { memo } from "react";
import {
  parseTime,
  getAssignedToField,
} from "Components/LiveMissionsTable/utils";
import { useSelector } from "react-redux";
import { getVehicles } from "Slices/vehicles/selectors";
import { getVehicleTypes } from "Slices/vehicleTypes/selectors";
import { getVehiclesUpdateData } from "Slices/vehiclesState";
import { useDispatch } from "react-redux";
import { closeAnyModal } from "Slices/modals";
import { ReactComponent as CloseIcon } from "../../../ListDataPagesModals/assets/closeIcon.svg";

import {
  Container,
  DeployedAt,
  DeployedAtTime,
  DeployedBy,
  Frame787883729,
  Frame787883744,
  Frame787883745,
  Frame787883747,
  Frame787883749,
  Label,
  Link,
  Link01,
  MissionName,
  MissionStatus,
  SidebarHeader,
} from "./styles";
import { MissionDetailsHeaderProps } from "../../types";
import { missionStatusesMap } from "Components/MissionPlanner/components/MissionPlannerLists/constants";

export const MissionDetailsHeader = memo(
  ({ mission, vehicle }: MissionDetailsHeaderProps) => {
    const dispatch = useDispatch();
    const vehicles = useSelector(getVehicles);
    const vehicleTypes = useSelector(getVehicleTypes);
    const vehiclesState = useSelector(getVehiclesUpdateData);
    const deployedAt =
      mission.deployedAt || mission.timeStamp
        ? parseTime(mission.deployedAt || mission.timeStamp)
        : "N/A";

    const handleClose = () => {
      dispatch(closeAnyModal());
    };

    const { icon, statusName } = missionStatusesMap[mission.status] ?? {};

    return (
      <SidebarHeader>
        <Frame787883729>
          <Frame787883749>
            <MissionStatus data-test-id="show-mission-details-status">
              {icon}
              <Label>{statusName}</Label>
            </MissionStatus>
            <Container>
              <Link
                onClick={handleClose}
                data-test-id="close-mission-details-button"
              >
                <Link01>Close</Link01>
                <CloseIcon />
              </Link>
            </Container>
          </Frame787883749>
          <MissionName
            id="mission-details-title"
            data-test-id="show-mission-details-name"
          >
            {mission.name}
          </MissionName>
          <Frame787883747>
            <Frame787883744>
              <DeployedAt>Deployed at:</DeployedAt>
              <DeployedAtTime data-test-id="show-mission-details-deployed-time">
                {deployedAt}
              </DeployedAtTime>
            </Frame787883744>
            <Frame787883745>
              <DeployedBy>Assigned to:</DeployedBy>
              <span data-test-id="show-mission-details-vehicle-name">
                {getAssignedToField(
                  vehicle?.id || mission.vehicle,
                  vehicles,
                  vehicleTypes,
                  vehiclesState
                )}
              </span>
            </Frame787883745>
          </Frame787883747>
        </Frame787883729>
      </SidebarHeader>
    );
  }
);
